@if (product$ | async; as product) {
  @if (product.pictos?.length > 0) {
    <div class="pictos">
      @for (picto of product.pictos; track picto; let i = $index) {
        <div>
          <cx-media
            [container]="picto.image"
            [alt]="picto.name"
          [title]="picto.name"></cx-media>
        </div>
      }
    </div>
  }
  @if (product?.description?.length > 0) {
    <div
      class="product-description"
      [innerHTML]="product?.description"
    ></div>
  }
}
@if (components$ | async; as components) {
  @for (component of components; track component; let i = $index) {
    <div class="tab-container">
      <a (click)="select(i, $event)" [class.active]="(changeIcon && i === activeTabNum)">
        {{ component.title | cxTranslate: { param: tabTitleParams[i] | async } }}
        <app-custom-icons [type]="(changeIcon && i === activeTabNum) ? iconTypes.MINUS : iconTypes.PLUS" ></app-custom-icons>
      </a>
      <div @fadeIn @fadeOut class="content-container" [class.active]="(changeIcon && i === activeTabNum)">
        <ng-template [cxOutlet]="component.flexType" [cxOutletContext]="{}">
          <ng-container [cxComponentWrapper]="component"></ng-container>
        </ng-template>
      </div>
    </div>
  }
}
